<template>
	<div class="shop-container">
		<div class="t" v-if="paymentInfo.type">
			<div class="tl">
				<div class="tl-img">
					<!-- <i class="icon iconfont iconsuccess"></i> -->
					<i v-if="status == 2" class="icon  iconfont iconsuccess"></i>
					<img v-else class="fail" src="@/assets/icon/fail.png" alt />
				</div>
				<div class="tl-info">
					<h3 v-if="status == 2 && order_type=='normal'">支付成功!</h3>
					<h3 v-if="status == 2 && order_type=='zero_order'">兑换成功!</h3>
					<h3 v-else-if="status != 2">Fail!</h3>
				</div>
			</div>
			<div class="tr">
				<div class="tr-btn back" @click="$router.replace('home')">回到首页</div>
				<div class="tr-btn go">
					<!-- <router-link :to="{ name: 'orderDetail', params: { order_id: order_id } }">查看详情</router-link> -->
					<div @click="orderDetail()">查看详情</div>
				</div>
			</div>
		</div>
		<div class="b">
			<div class="title">
				<h2>买购物车中商品的人还买了</h2>
				<ProductRowFive :list="goodsList"></ProductRowFive>
			</div>
		</div>
		<el-dialog title="感谢支持爱心拍卖！快将你的善举分享给朋友吧！" :visible.sync="shareWelfare"  width="600px" class="sharePoster">
			<div class="dia">
			  <div>
			    <img :src="$store.state.config.pay_finish_share" style="max-width:580px"/>
				<div class="poster-tips">注：如果无法下载，可右键另存为</div>
			    <div class="dia-desc" style="text-align: -webkit-center;" @click="savePoster()">
					<div class="dia-btn">保存图片</div>
				</div>
			  </div>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
import ProductRowFive from '@/components/layout/ProductRowFive.vue';
export default {
	name: 'PaySuccess',
	components: { ProductRowFive },
	props: {},
	data() {
		return {
			order_id: '',
			goodsList: [],
			status: '',
			paymentInfo:{},
			shareWelfare:false,
			order_type:'normal',
		};
	},
	watch: {},
	computed: {},
	methods: {
		getPickGoods() {
			let data = {
				page: 1,
				limit: 10
			};
			this.$api.getPickGoods(data).then(res => {
				if (res.status) {
					this.goodsList = res.data.list;
				}
			});
		},
		orderDetail() {
			let _this = this;
			if(this.type == 'offline') {
				this.$router.push({ name: "orderDetail", params: {order_id: this.order_id} });
				return
			}
			if(this.order_type == 'zero_order') {
				this.$router.push({ name: "orderDetail", params: {order_id: this.order_id} });
				return
			}
			if (this.order_id && this.paymentInfo.type == 1) {
				this.$router.push({ name: "orderDetail", params: {order_id: this.order_id} });
			} else if (this.paymentInfo.type == 2) {
				
				this.$router.push({ name: "balance"});
				
			} else if (this.paymentInfo.type == 5 || this.paymentInfo.type == 6) {
	
				this.$router.push({ name: "home"});
			}else if(this.paymentInfo.type == 10){
				_this.$api.getEnrollInfo({id:_this.paymentInfo.rel[0]['source_id']}).then( res => {
					if(res.status){
						_this.$router.push({ name: "auction", params: {goodsId: res.data.auction_id}});
					}
				});
			}
		},
		//下载图片
		savePoster(){
			
				this.$api.addRecord({
				  type: "6",
				  api_method: "savePoster",
				  platform: "1",
				  code:'pay_success',
				  rel_id:this.$route.query.id
				});
				// 强制下载图片
		 	    const image = new Image();
		 	    image.src = this.$store.state.config.pay_finish_share+'?' + new Date().getTime();
				
		 	    // 解决跨域 Canvas 污染问题
		 	    image.setAttribute('crossOrigin', 'anonymous');
		 	    // eslint-disable-next-line func-names
		 	    image.onload = function () {
		 	      const canvas = document.createElement('canvas');
		 	      canvas.width = image.width;
		 	      canvas.height = image.height;
		 	      const context = canvas.getContext('2d');
		 	      context.drawImage(image, 0, 0, image.width, image.height);
		 	      const url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
		 	      const a = document.createElement('a'); // 生成一个a元素
		 	      a.download = 'share'; // 设置图片名称
		 	      a.href = url; // 将生成的URL设置为a.href属性
		 	      a.click();
		 	    };
		},
	},
	created() {},
	mounted() {
		let _this = this;
		if (this.$storage.get('userToken')) {
			if(this.$route.query.type && this.$route.query.order_id){
				this.order_id = this.$route.query.order_id;
				this.order_type = this.$route.query.type;
				this.status = 2;
				this.paymentInfo.type = 1
				// setTimeout(() => {
				// 	if (_this.$store.state.config.open_pay_finish_share && _this.$store.state.config.open_pay_finish_share == 1){
				// 		_this.shareWelfare = true;
				// 	}
				// }, 500)
				
			}else{
				
				this.$api
					.paymentInfo({
						payment_id: this.$route.query.id,
					})
					.then(res => {
						this.paymentInfo = res.data
						this.status = res.data.status;
						this.order_id = res.data.rel[0].source_id;
						if(this.status==2 && res.data.order_type == 12){
							if (this.$store.state.config.open_pay_finish_share && this.$store.state.config.open_pay_finish_share == 1){
								setTimeout(() => {
									_this.shareWelfare = true;
								}, 500)
							}
						}
					});
			}
		}
		this.getPickGoods();
	}
};
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variable.scss';


.shop-container {
	padding-top: 20px;
}

.fail {
	width: 64px;
	height: 64px;
}
.t {
	margin-bottom: 26px;
	padding: 0 0 28px 0;
	height: 68px;
	border-bottom: 1px solid #e0e0e0;
	.tl {
		.tl-img {
			float: left;
			width: 64px;
			height: 64px;
			margin-right: 20px;
			.icon {
				font-size: 64px;
				color: #84c54d;
			}
		}
		.tl-info {
			float: left;
			h3 {
				color: #424242;
				font-size: 22px;
				font-weight: normal;
				margin-top: 20px;
			}
		}
	}
	.tr {
		float: right;
		.tr-btn {
			display: inline-block;
			width: 180px;
			margin-left: 12px;
			margin-top: 5px;
			height: 38px;
			line-height: 38px;
			text-align: center;
			cursor: pointer;
			-webkit-transition: all 0.4s;
			transition: all 0.4s;
			&.back {
				border: 1px solid #b0b0b0;
				color: #757575;
				&:hover {
					background: #fff;
				}
			}
			&.go {
				background: $theme-color;
				color: #fff;
				border: 1px solid $theme-color;
			}
		}
	}
}
.b {
	.title {
		h2 {
			text-align: center;
			height: 50px;
			font-size: 28px;
			font-weight: 400;
			color: #757575;
			margin-bottom: 20px;
		}
	}
}


</style>

<style lang="scss">
	.dia {
	  margin: 10px;
	  display: flex;
	  align-items: center;
	  flex-direction: column;
	  margin-top: 30px;
	  &-title {
	    font-size: 24px;
	    color: #222222;
	    margin-top: 36px;
	  }
	  &-desc {
	    font-size: 14px;
	    color: #222222;
	    margin-top: 20px;
	    margin-bottom: 20px;
	  }
	  &-btn {
	    &-wrap {
	      display: flex;
	      align-items: center;
	    }
	    cursor: pointer;
	    width: 200px;
	    height: 60px;
	    line-height: 60px;
	    background: #ffc300;
	    border-radius: 10px;
	
	    font-size: 24px;
	    font-weight: 400;
	    color: #fff;
	    text-align: center;
	    margin-top: 30px;
	    margin-bottom: 20px;
	    &.cancel {
	      margin-right: 20px;
	      background: #999999;
	    }
	  }
	}
	.el-dialog__header {
	  // background: #ffc300 !important;
	}
/* 	.el-dialog__title {
	  color: #fff !important;
	} */
	.el-dialog__headerbtn .el-dialog__close {
	  color: #fff;
	}
	.dia-title {
	  text-align: center;
	}
	
	.sharePoster .el-dialog__title{
		font-weight: bold;
		color: #303133;
	}
	.sharePoster .poster-tips{
		text-align: center;
		margin-top: 10px;
	}
	.sharePoster .dia-btn{
		margin-top:0px;
		margin-bottom: 0px;
	}
</style>